export default "__VITE_PUBLIC_ASSET__7c3bf4c9__"